import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'
import Window from '../../../common/Window'
import Loading from '../../../common/component/Loading'
import Config from '../../../Config'

class SurveyAnswer extends Component {
  constructor (props) {
    super(props)
    const initialState = this.getInitialState()
    this.state = initialState
    this.apiUrl = Config.companyUserApiUrl.surveyAnswer
    this.userRole = 'companyUser'
  }
  getInitialState () {
    return {
      isLoaded: false,
      surveyMainItems: [],
      surveyBigQuestionItems: [],
      surveyMediumQuestionItems: [],
      surveySmallQuestionItems: [],
      surveyChoiseItems: [],
      answerId: null,
      answerItems: [],
      choiceInputs: {},
      choiceInputs2: {},
      japaneseSumByIndex: {},
      foreignerSumByIndex: {},
      foreignerSubscriberSumByIndex: {},
      mediumQuestionTotalsumByIndex: {},
      unknownUnsubscribedSumByIndex: {},
      displaySumByIndex: {},
      inputs: {},
      errorFields: {},
    }
  }
  componentDidMount() {
    const dt = new Date();
    const currentYear = dt.getFullYear();
    const fiscalYear = dt.getMonth() < 3 ? currentYear - 1 : currentYear;
    this.loadServey(fiscalYear);
  }

  componentDidUpdate(prevProps, prevState) {
    // surveyMediumQuestionItems が更新された場合のみ処理を実行
    if (prevState.surveyMediumQuestionItems !== this.state.surveyMediumQuestionItems && this.state.surveyMediumQuestionItems.length > 0) {
      this.state.surveyMediumQuestionItems.forEach((mediumItem) => {
        const linkedSmallQuestions = this.state.surveySmallQuestionItems.filter(
          (smallItem) => smallItem.medium_question_id == mediumItem.id
        );
        let keyIndex = 0;
        let key = '';
        linkedSmallQuestions.forEach((smallItem) => {
          if(key == `${mediumItem.id}-${smallItem.setsumon_text}`) {
            keyIndex++
          } else {
            keyIndex = 1
            key = `${mediumItem.id}-${smallItem.setsumon_text}`
          }
          const answerValue = this.state.answerItems[smallItem.id];
          if (answerValue && smallItem.summary_flg == 1) {
            const numericValue = parseInt(answerValue, 10) || 0; // value を数値に変換
            this.calculateSum(key, mediumItem.id, keyIndex, numericValue);
          }
        });
      });
    }
  }
  loadServey(year) {
    const onSuccess = (res) => {
      const surveyQuestionData = res.body.data
      let answerItems = surveyQuestionData && surveyQuestionData.surveyAnswerItems && surveyQuestionData.surveyAnswerItems.length > 0
          ? JSON.parse(surveyQuestionData.surveyAnswerItems[0].answerData) : {}; // 空の配列からオブジェクトに変更
      
      const surveySmallQuestionItems = surveyQuestionData && surveyQuestionData.surveySmallQuestionItems 
          ? surveyQuestionData.surveySmallQuestionItems : [];
      const surveyChoiseItems = surveyQuestionData && surveyQuestionData.surveyChoiseItems 
          ? surveyQuestionData.surveyChoiseItems : [];

      surveySmallQuestionItems.forEach(smallItem => {
        // ラジオボタン (setsumon_type == 1) の初期値設定
        if (smallItem.setsumon_type == 1 && !answerItems[smallItem.id]) {
          const firstChoise = surveyChoiseItems.find(choise => choise.choise_type == smallItem.setsumon_type);
          if (firstChoise) {
            answerItems[smallItem.id] = firstChoise.choise_sort;
          }
        }
      });

      const numberOfAgeGroups = 12; // 年代の数
      const newChoiceInputs2 = {};
      const newJapaneseSumByIndex = {};
      const newForeignerSumByIndex = {};
      const newForeignerSubscriberSumByIndex = {};
      const newMediumQuestionTotalsumByIndex = {};
      const newUnknownUnsubscribedSumByIndex = {};
      const newDisplaySumByIndex = {};

      // surveyMediumQuestionItems と surveySmallQuestionItems を使って、全ての集計データを構築
      const mediumQuestionItems = (surveyQuestionData && surveyQuestionData.surveyMediumQuestionItems) || [];

      mediumQuestionItems.forEach((mediumItem) => {
        const linkedSmallQuestions = surveySmallQuestionItems.filter(
          (smallItem) => smallItem.medium_question_id == mediumItem.id && smallItem.summary_flg == 1
        );

        linkedSmallQuestions.forEach((smallItem) => {
          const key = `${mediumItem.id}-${smallItem.setsumon_text}`;

          if (!newChoiceInputs2[key]) {
            newChoiceInputs2[key] = { inputs: [], sumByIndex: {}, sum: 0, totalsum: 0 };
          }

          for (let i = 1; i <= numberOfAgeGroups; i++) {
            // answerItems から既存の回答値を取得、なければ 0
            const initialValue = parseInt(answerItems[`${smallItem.id}-${i}`] || '0', 10);
            
            // 既存のinputs配列に要素がない場合にpush
            if (newChoiceInputs2[key].inputs.length <= i) {
                newChoiceInputs2[key].inputs.push({ index: i, value: initialValue });
            } else {
                newChoiceInputs2[key].inputs[i] = { index: i, value: initialValue };
            }
            newChoiceInputs2[key].sumByIndex[i] = initialValue;
          }

          // 各小項目 (key) ごとの横合計を計算
          newChoiceInputs2[key].sum = Object.values(newChoiceInputs2[key].sumByIndex).reduce((total, val) => total + val, 0);
        });
      });

      // choiceInputs2 を基に、各種合計 (japaneseSumByIndex など) を計算
      const {
        japaneseSumByIndex: calculatedJapaneseSum,
        foreignerSumByIndex: calculatedForeignerSum,
        foreignerSubscriberSumByIndex: calculatedForeignerSubscriberSum,
        mediumQuestionTotalsumByIndex: calculatedMediumQuestionTotalsum,
        unknownUnsubscribedSumByIndex: calculatedUnknownUnsubscribedSum,
        displaySumByIndex: calculatedDisplaySum,
      } = this.calculateAllSumsInitial(newChoiceInputs2, surveySmallQuestionItems, numberOfAgeGroups);

      this.setState({
        isLoaded: true,
        surveyMainItems: surveyQuestionData && surveyQuestionData.surveyMainItems && surveyQuestionData.surveyMainItems.length > 0 
          ? surveyQuestionData.surveyMainItems[0] : [],
        surveyBigQuestionItems: surveyQuestionData && surveyQuestionData.surveyBigQuestionItems 
          ? surveyQuestionData.surveyBigQuestionItems : [],
        surveyMediumQuestionItems: surveyQuestionData && surveyQuestionData.surveyMediumQuestionItems 
          ? surveyQuestionData.surveyMediumQuestionItems : [],
        surveySmallQuestionItems: surveySmallQuestionItems,
        surveyChoiseItems: surveyChoiseItems,
        answerId: surveyQuestionData && surveyQuestionData.surveyAnswerItems && surveyQuestionData.surveyAnswerItems.length > 0 
          ? surveyQuestionData.surveyAnswerItems[0].id : null,
        answerItems: answerItems,
        choiceInputs2: newChoiceInputs2,
        japaneseSumByIndex: calculatedJapaneseSum,
        foreignerSumByIndex: calculatedForeignerSum,
        foreignerSubscriberSumByIndex: calculatedForeignerSubscriberSum,
        mediumQuestionTotalsumByIndex: calculatedMediumQuestionTotalsum,
        unknownUnsubscribedSumByIndex: calculatedUnknownUnsubscribedSum,
        displaySumByIndex: calculatedDisplaySum,
      });
    }
    const params = {
      command: 'getQuestion',
      surveyValue: { year: year },
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
  }
  saveServey () {
    const servey = this.state
    const id = servey.answerId || null

    let hasError = false;
    let errorFields = {};

    // バリデーション
    if (servey.answerItems[1] === '' || servey.answerItems[1] === undefined) {
      Window.alert('会社名は必須です。');
      errorFields[1] = true;
      hasError = true;
    }
    if (servey.answerItems[2] === '' || servey.answerItems[2] === undefined) {
      Window.alert('会社所在地は必須です。');
      errorFields[2] = true;
      hasError = true;
    }
    if (servey.answerItems[3] === '' || servey.answerItems[3] === undefined) {
      Window.alert('会社所在地は必須です。');
      errorFields[3] = true;
      hasError = true;
    }

    // 電話番号バリデーション
    const phoneRegex = /^(0\d{1,4}-\d{1,4}-\d{4}|0\d{9,10})$/;
    if (servey.answerItems[4] && !phoneRegex.test(servey.answerItems[4])) {
      Window.alert('電話番号は正しい形式で入力してください。\n（例：090-1234-5678 または 09012345678）');
      errorFields[4] = true;
      hasError = true;
    }
    if (servey.answerItems[5] && !phoneRegex.test(servey.answerItems[5])) {
      Window.alert('FAX番号は正しい形式で入力してください。\n（例：090-1234-5678 または 09012345678）');
      errorFields[5] = true;
      hasError = true;
    }

    // メールアドレスバリデーション
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (servey.answerItems[6] && !emailRegex.test(servey.answerItems[6])) {
      Window.alert('有効なメールアドレスを入力してください。');
      errorFields[6] = true;
      hasError = true;
    }

    // 所属支部名バリデーション
    if (
      servey.answerItems[7] === "1" &&
      (servey.answerItems[8] === '' || servey.answerItems[8] === undefined)
    ) {
      Window.alert('所属支部名を選択してください。');
      errorFields[8] = true;
      hasError = true;
    }

    if (hasError) {
      // エラーがある場合、該当フィールドに赤色の枠を表示
      this.setState({ errorFields });
      return false;
    }

    let updateOrInsert

    if (id) { // 更新
      updateOrInsert = (oldSurveyValue) => {
        const result = {
          id: id,
          surveyMainId: servey.surveyMainItems.id,
          answerData: JSON.stringify(servey.answerItems),
        }
        return result
      }
    } else { // 新規登録
      updateOrInsert = (oldSurveyValue) => {
        const result = {
          id: this.uuid(),
          surveyMainId: servey.surveyMainItems.id,
          answerData: JSON.stringify(servey.answerItems),
        }
        return result
      }
    }
    const surveyValue = updateOrInsert(servey)
    let paramsToSet = [];
    if(id) {
      paramsToSet = {
        command: 'set',
        surveyValue: surveyValue
      }
    } else {
      paramsToSet = {
        command: 'add',
        surveyValue: surveyValue
      }
    }
    const onSuccessToPost = (res) => {
      Window.alert('保存しました', () => {
        this.props.history.push('/company_user/survey_answer')
        this.setState({ errorFields: {} });
        Window.closeDialog()
      })
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToSet, onSuccessToPost)
  }
  onPageMenuClicked (name) {
    const id = this.state.id
    switch (name) {
      case 'back':
        this.props.history.push('/company_user/')
        break
      default:
        break
    }
  }
  uuid () {
    let uuid = ''
    let i
    let random
    for (i = 0; i < 32; i++) {
      random = Math.random() * 16 | 0

      if (i === 8 || i === 12 || i === 16 || i === 20) {
        uuid += '-'
      }
      uuid += (i === 12 ? 4 : (i === 16 ? ((random & 3) | 8) : random)).toString(16)
    }
    return uuid
  }
  calculateAllSumsInitial = (currentChoiceInputs2, surveySmallQuestionItems, numberOfAgeGroups) => {
    const nextJapaneseSumByIndex = {};
    const nextForeignerSumByIndex = {};
    const nextForeignerSubscriberSumByIndex = {};
    const nextMediumQuestionTotalsumByIndex = {};
    const nextUnknownUnsubscribedSumByIndex = {};
    const nextDisplaySumByIndex = {};

    // groupedSumByIndex は、各中項目内の小項目の合計（未加入・不明合算前）を保持
    const groupedSumByIndex = {};

    Object.keys(currentChoiceInputs2).forEach((key) => {
        const groupKey = key.split("-")[0];
        const setsumonText = key.split("-").slice(1).join("-");

        // (A) 小項目 (key) ごとの年代別合計 (currentSmallItemSumByIndex) を計算
        const currentSmallItemSumByIndex = {};
        for (let i = 1; i <= numberOfAgeGroups; i++) {
            currentSmallItemSumByIndex[i] = (currentSmallItemSumByIndex[i] || 0) + (currentChoiceInputs2[key].inputs[i].value || 0);
        }
        currentChoiceInputs2[key].sumByIndex = currentSmallItemSumByIndex; // 小項目ごとの年代別合計を設定
        currentChoiceInputs2[key].sum = Object.values(currentSmallItemSumByIndex).reduce((total, val) => total + val, 0); // 小項目ごとの横合計

        // (B) groupedSumByIndex (中項目ごとの純粋な年代別合計) を計算
        if (!groupedSumByIndex[groupKey]) groupedSumByIndex[groupKey] = {};
        Object.keys(currentSmallItemSumByIndex).forEach(index => {
            groupedSumByIndex[groupKey][index] = (groupedSumByIndex[groupKey][index] || 0) + currentSmallItemSumByIndex[index];
        });

        // (C) カテゴリー別合計 (japaneseSum, foreignerSumなど) を計算
        if (!nextJapaneseSumByIndex[groupKey]) nextJapaneseSumByIndex[groupKey] = {};
        if (!nextForeignerSumByIndex[groupKey]) nextForeignerSumByIndex[groupKey] = {};
        if (!nextForeignerSubscriberSumByIndex[groupKey]) nextForeignerSubscriberSumByIndex[groupKey] = {};

        const isJapanese = setsumonText.includes("日本人");
        const isForeignerSubscriber = setsumonText.includes("外国人加入者");
        const isForeigner = setsumonText.includes("外国人") && !isForeignerSubscriber;

        Object.keys(currentSmallItemSumByIndex).forEach(index => {
            const val = currentSmallItemSumByIndex[index];
            if (isJapanese) {
                nextJapaneseSumByIndex[groupKey][index] = (nextJapaneseSumByIndex[groupKey][index] || 0) + val;
            } else if (isForeignerSubscriber) {
                nextForeignerSubscriberSumByIndex[groupKey][index] = (nextForeignerSubscriberSumByIndex[groupKey][index] || 0) + val;
            } else if (isForeigner) {
                nextForeignerSumByIndex[groupKey][index] = (nextForeignerSumByIndex[groupKey][index] || 0) + val;
            }
        });
    });
    // (D) nextMediumQuestionTotalsumByIndex を更新 (純粋な年代別合計をコピー)
    Object.assign(nextMediumQuestionTotalsumByIndex, groupedSumByIndex);

    // --- ステップ 4: 各中項目 (groupKey) の全体の横合計 (totalsum) を計算し、currentChoiceInputs2 に設定 ---
    Object.keys(currentChoiceInputs2).forEach((key) => {
        const groupKey = key.split("-")[0];
        currentChoiceInputs2[key].totalsum = Object.values(groupedSumByIndex[groupKey] || {}).reduce((total, val) => total + val, 0);
    });

    // --- ステップ 5: 「未加入・不明」の計算ロジック ---
    const calculateUnknownUnsubscribed = (baseQId, subQId, resultQId) => {
        const baseSums = nextMediumQuestionTotalsumByIndex[baseQId];
        const subSums = nextMediumQuestionTotalsumByIndex[subQId];

        if (baseSums && subSums) {
            const resultSums = {};
            const allIndices = [...new Set([...Object.keys(baseSums), ...Object.keys(subSums)])].sort((a, b) => parseInt(a, 10) - parseInt(b, 10));

            allIndices.forEach(index => {
                const baseVal = baseSums[index] || 0;
                const subVal = subSums[index] || 0;
                resultSums[index] = baseVal - subVal;
            });
            nextUnknownUnsubscribedSumByIndex[resultQId] = resultSums;
        } else {
            delete nextUnknownUnsubscribedSumByIndex[resultQId];
        }
    };

    calculateUnknownUnsubscribed(11, 15, 15);
    calculateUnknownUnsubscribed(12, 16, 16);
    calculateUnknownUnsubscribed(17, 19, 19);
    calculateUnknownUnsubscribed(18, 20, 20);

    // --- ステップ 6: 最終表示用「各年代小計」 (nextDisplaySumByIndex) を計算 ---
    Object.keys(nextMediumQuestionTotalsumByIndex).forEach(groupKey => {
      const currentPureTotalsumByIndex = { ...nextMediumQuestionTotalsumByIndex[groupKey] };
      const unknownData = nextUnknownUnsubscribedSumByIndex[groupKey];

      // 全年代のインデックスを確実にカバーするためにループ
      for (let i = 1; i <= numberOfAgeGroups; i++) {
        // unknownDataが存在する場合のみ unknownData[i] にアクセスし、
        // 存在しない（undefined/nullの場合）または値がない場合は 0 を加算する
        currentPureTotalsumByIndex[i] = (currentPureTotalsumByIndex[i] || 0) + ((unknownData && unknownData[i]) || 0);
      }
      nextDisplaySumByIndex[groupKey] = currentPureTotalsumByIndex; // 368行目付近
    });

    return {
      japaneseSumByIndex: nextJapaneseSumByIndex,
      foreignerSumByIndex: nextForeignerSumByIndex,
      foreignerSubscriberSumByIndex: nextForeignerSubscriberSumByIndex,
      mediumQuestionTotalsumByIndex: nextMediumQuestionTotalsumByIndex,
      unknownUnsubscribedSumByIndex: nextUnknownUnsubscribedSumByIndex,
      displaySumByIndex: nextDisplaySumByIndex,
    };
  }
  sumChanged = (name, e) => {
    const value = e.target.value.replace(/[^0-9]/g, ""); // 数字以外の文字を削除
    const numericValue = value ? parseInt(value, 10) : 0;

    const { medium: inputKey, small: inputIndex } = e.target.dataset;
    const numericInputIndex = Number(inputIndex);
    if (!inputKey || !inputIndex) {
      console.error("データ属性 'data-medium' または 'data-small' が不足しています:", e.target);
      return;
    }

    this.calculateSum(name, inputKey, numericInputIndex, numericValue);
  }
  calculateSum = (name, inputKey, inputIndex, numericValue) => {
    this.setState((prevState) => {
      // 既存のstateをコピーして変更対象を明確にする
      const newChoiceInputs = { ...prevState.choiceInputs2 };

      // 新しい集計結果を格納するオブジェクトを初期化
      // これにより、毎回最新のデータでStateが再構築されることを保証
      const nextJapaneseSumByIndex = {};
      const nextForeignerSumByIndex = {};
      const nextForeignerSubscriberSumByIndex = {};
      const nextMediumQuestionTotalsumByIndex = {}; // 未加入・不明合算前の純粋な中項目年代別合計
      const nextUnknownUnsubscribedSumByIndex = {}; // 未加入・不明の計算結果
      const nextDisplaySumByIndex = {}; // 最終的に表示する「各年代小計」（未加入・不明合算済み）
      const numberOfAgeGroups = 12;

      // --- ステップ 1: 変更された入力値 (newChoiceInputs) を更新 ---
      if (!newChoiceInputs[name]) {
        newChoiceInputs[name] = { inputs: [], sumByIndex: {}, sum: 0, totalsum: 0 };
      }

      // まず、既存の inputs 配列からインデックスと値のマップを作成し、新しい inputs 配列を生成
      const currentInputsMap = new Map(newChoiceInputs[name].inputs.map(input => [input.index, input.value]));
      const newInputsArray = [];

      for (let i = 1; i <= numberOfAgeGroups; i++) {
        const value = currentInputsMap.has(i) ? currentInputsMap.get(i) : 0;
        newInputsArray.push({ index: i, value: value });
        newChoiceInputs[name].sumByIndex[i] = newChoiceInputs[name].sumByIndex[i] || 0;
      }

      const updatedInputEntry = newInputsArray.find(input => input.index === inputIndex);
      if (updatedInputEntry) {
          updatedInputEntry.value = numericValue;
      } else {
          newInputsArray.push({ index: inputIndex, value: numericValue });
          newChoiceInputs[name].sumByIndex[inputIndex] = numericValue;
      }

      // newInputsArray を newChoiceInputs[name].inputs にセット
      newChoiceInputs[name].inputs = newInputsArray;

      // sumByIndex の該当する inputIndex の値を更新
      newChoiceInputs[name].sumByIndex[inputIndex] = numericValue;

      // --- ステップ 2 & 3: 各小項目・中項目・カテゴリー別合計の再計算 ---
      const groupedSumByIndex = {}; 

      Object.keys(newChoiceInputs).forEach((key) => {
        const groupKey = key.split("-")[0];
        const setsumonText = key.split("-").slice(1).join("-");

        // (A) 小項目 (key) ごとの年代別合計 (currentSmallItemSumByIndex) を計算
        const currentSmallItemSumByIndex = {};
        newChoiceInputs[key].inputs.forEach((input) => {
            currentSmallItemSumByIndex[input.index] = (currentSmallItemSumByIndex[input.index] || 0) + input.value;
        });
        newChoiceInputs[key].sumByIndex = currentSmallItemSumByIndex; // 小項目ごとの年代別合計を設定
        newChoiceInputs[key].sum = Object.values(currentSmallItemSumByIndex).reduce((total, val) => total + val, 0); // 小項目ごとの横合計

        // (B) groupedSumByIndex (中項目ごとの純粋な年代別合計) を計算
        if (!groupedSumByIndex[groupKey]) groupedSumByIndex[groupKey] = {};
        Object.keys(currentSmallItemSumByIndex).forEach(index => {
            groupedSumByIndex[groupKey][index] = (groupedSumByIndex[groupKey][index] || 0) + currentSmallItemSumByIndex[index];
        });

        // (C) カテゴリー別合計 (japaneseSum, foreignerSumなど) を計算
        if (!nextJapaneseSumByIndex[groupKey]) nextJapaneseSumByIndex[groupKey] = {};
        if (!nextForeignerSumByIndex[groupKey] ) nextForeignerSumByIndex[groupKey] = {}; // 修正: ここも初期化が必要
        if (!nextForeignerSubscriberSumByIndex[groupKey]) nextForeignerSubscriberSumByIndex[groupKey] = {};

        const isJapanese = setsumonText.includes("日本人");
        const isForeignerSubscriber = setsumonText.includes("外国人加入者");
        const isForeigner = setsumonText.includes("外国人") && !isForeignerSubscriber;

        Object.keys(currentSmallItemSumByIndex).forEach(index => {
            const val = currentSmallItemSumByIndex[index];
            if (isJapanese) {
                nextJapaneseSumByIndex[groupKey][index] = (nextJapaneseSumByIndex[groupKey][index] || 0) + val;
            } else if (isForeignerSubscriber) {
                nextForeignerSubscriberSumByIndex[groupKey][index] = (nextForeignerSubscriberSumByIndex[groupKey][index] || 0) + val;
            } else if (isForeigner) {
                nextForeignerSumByIndex[groupKey][index] = (nextForeignerSumByIndex[groupKey][index] || 0) + val;
            }
        });
      });
      // (D) nextMediumQuestionTotalsumByIndex を更新 (純粋な年代別合計をコピー)
      Object.assign(nextMediumQuestionTotalsumByIndex, groupedSumByIndex);

      // --- ステップ 4: 各中項目 (groupKey) の全体の横合計 (totalsum) を計算し、newChoiceInputs に設定 ---
      Object.keys(newChoiceInputs).forEach((key) => {
        const groupKey = key.split("-")[0];
        // groupedSumByIndex に基づいて totalsum を計算
        newChoiceInputs[key].totalsum = Object.values(groupedSumByIndex[groupKey] || {}).reduce((total, val) => total + val, 0);
      });
      

      // --- ステップ 5: 「未加入・不明」の計算ロジック ---
      const calculateUnknownUnsubscribed = (baseQId, subQId, resultQId) => {
          const baseSums = nextMediumQuestionTotalsumByIndex[baseQId];
          const subSums = nextMediumQuestionTotalsumByIndex[subQId];

          if (baseSums && subSums) {
              const resultSums = {};
              const allIndices = [...new Set([...Object.keys(baseSums), ...Object.keys(subSums)])].sort((a, b) => parseInt(a, 10) - parseInt(b, 10));

              allIndices.forEach(index => {
                  const baseVal = baseSums[index] || 0;
                  const subVal = subSums[index] || 0;
                  resultSums[index] = baseVal - subVal;
              });
              nextUnknownUnsubscribedSumByIndex[resultQId] = resultSums;
          } else {
            // データが不完全な場合は、このグループの「未加入・不明」をクリア
            delete nextUnknownUnsubscribedSumByIndex[resultQId];
          }
      };

      // 質問の減算組み合わせ (中項目IDを指定)
      calculateUnknownUnsubscribed(11, 15, 15);
      calculateUnknownUnsubscribed(12, 16, 16);
      calculateUnknownUnsubscribed(17, 19, 19);
      calculateUnknownUnsubscribed(18, 20, 20);

      // --- ステップ 6: 実際に表示する「各年代小計」 (nextDisplaySumByIndex) を計算 ---
      //    nextMediumQuestionTotalsumByIndex (純粋な合計) と nextUnknownUnsubscribedSumByIndex を合算する
      Object.keys(nextMediumQuestionTotalsumByIndex).forEach(groupKey => {
        const currentPureTotalsumByIndex = { ...nextMediumQuestionTotalsumByIndex[groupKey] };
        const unknownData = nextUnknownUnsubscribedSumByIndex[groupKey];

        if (unknownData) {
          // 「未加入・不明」がある場合は合算
          // pureTotalsumByIndex のコピーに unknownData を加算していく
          Object.keys(unknownData).forEach(index => {
            currentPureTotalsumByIndex[index] = (currentPureTotalsumByIndex[index] || 0) + unknownData[index];
          });
        }
        // 最終的な表示用合計として設定
        nextDisplaySumByIndex[groupKey] = currentPureTotalsumByIndex;
      });

      // --- setState で最終的なstateオブジェクトを更新 ---
      return {
        choiceInputs2: newChoiceInputs,
        japaneseSumByIndex: nextJapaneseSumByIndex,
        foreignerSumByIndex: nextForeignerSumByIndex,
        foreignerSubscriberSumByIndex: nextForeignerSubscriberSumByIndex,
        mediumQuestionTotalsumByIndex: nextMediumQuestionTotalsumByIndex,
        unknownUnsubscribedSumByIndex: nextUnknownUnsubscribedSumByIndex,
        displaySumByIndex: nextDisplaySumByIndex,
      };
    });
  }

  renderSurveyDetail(state, summaryCnt) {
    const survey = state;
    const changed = (path, value) => {
      this.setState((prevState) => {
        const stateCopy = { ...prevState };

        // 深いプロパティを扱うためのユーティリティ
        const keys = Array.isArray(path) ? path : [path];
        let current = stateCopy;

        keys.slice(0, -1).forEach((key) => {
          current[key] = { ...current[key] }; // ネストされたオブジェクトをコピー
          current = current[key];
        });

        current[keys[keys.length - 1]] = value;

        return stateCopy;
      });
    };

    const bigQuestionItems = survey.surveyBigQuestionItems || [];
    const mediumQuestionItems = survey.surveyMediumQuestionItems || [];
    const smallQuestionItems = survey.surveySmallQuestionItems || [];
    const choiseItems = survey.surveyChoiseItems || [];
    const answerItems = survey.answerItems || [];

    let firstType1Set = false;
    let firstType2Set = false;
    let firstBigItemDisplayed = false;

    const renderTable1 = (bigItem) => {
      let rows = [];
      const linkedMediumQuestions = mediumQuestionItems.filter(
        (mediumItem) => mediumItem.big_question_id == bigItem.id
      );

      if (!firstType1Set) {
        rows.push(
          <tr key={`title-${bigItem.id}`}>
            <td colSpan="4" style={{ fontWeight: 'bold', fontSize: '1.3em' }}>
              １．回答会社連絡先等　以下の項目をご記入ください。
            </td>
          </tr>
        );
        firstType1Set = true;
      }

      let isBigItemDisplayed = false;
      let beforeSetsumonType = 0;
      linkedMediumQuestions.forEach((mediumItem) => {
        const linkedSmallQuestions = smallQuestionItems.filter(
          (smallItem) =>
            smallItem.big_question_id == bigItem.id &&
            smallItem.medium_question_id == mediumItem.id
        );

        linkedSmallQuestions.forEach((smallItem) => {
          const linkedChoises = choiseItems.filter(
            (choiseItem) => choiseItem.choise_type == smallItem.setsumon_type
          );

          let smallItemTitle = null;
          if (beforeSetsumonType == 2 && smallItem.setsumon_type == 0) {
            smallItemTitle = (
              <td style={{ width: '20%', paddingLeft: '45px' }}>
                {smallItem.setsumon_text}
              </td>
            );
          } else if (smallItem.setsumon_type == 2) {
            smallItemTitle = (
              <td style={{ width: '20%', paddingLeft: '45px' }}>
                {smallItem.setsumon_text}
              </td>
            );
          } else {
            smallItemTitle = (
              <td style={{ width: '20%', paddingLeft: '45px' }}>&nbsp;</td>
            );
          }
          beforeSetsumonType = smallItem.setsumon_type;

          const smallItemComment = (
            <td style={{ width: '40%', paddingLeft: '15px' }}>
              {bigItem.setsumon_comment}
            </td>
          );

          let choiceInputs = null;

          if (smallItem.setsumon_type == 1) {
            // ラジオボタンの場合
            choiceInputs = (
              <td colSpan="2">
                {linkedChoises.map((choise, index) => {
                  return (
                    <label
                      key={`choice-${smallItem.id}-${choise.choise_sort}`}
                      style={{ display: 'inline-flex', alignItems: 'center' }}
                    >
                      <input
                        type="radio"
                        name={`radio-${smallItem.id}`}
                        value={choise.choise_sort}
                        checked={answerItems[smallItem.id] == choise.choise_sort}
                        onChange={(e) =>
                          changed(['answerItems', smallItem.id], e.target.value)
                        }
                      />
                      <span style={{ marginLeft: '5px' }}>{choise.choise_text}</span>
                    </label>
                  );
                })}
              </td>
            );
          } else if (smallItem.setsumon_type == 2 || smallItem.setsumon_type == 3) {
            // セレクトボックスの場合
            choiceInputs = (
              <td colSpan="2">
                <select
                  value={answerItems[smallItem.id] || ''}
                  onChange={(e) =>
                    changed(['answerItems', smallItem.id], e.target.value)
                  }
                  style={{ borderColor: (survey.errorFields && survey.errorFields[smallItem.id]) ? 'red' : 'initial', maxWidth: '150px' }}
                >
                  <option value="">選択してください</option>
                  {linkedChoises.map((choise) => (
                    <option
                      key={`choice-${smallItem.id}-${choise.choise_sort}`}
                      value={choise.choise_sort}
                    >
                      {choise.choise_text}
                    </option>
                  ))}
                </select>
              </td>
            );
          } else {
            // テキストボックスの場合
            choiceInputs = (
              <td colSpan="2">
                <input
                  type="text"
                  style={{ width: '100%', maxWidth: '400px', borderColor: (survey.errorFields && survey.errorFields[smallItem.id]) ? 'red' : 'initial' }}
                  value={answerItems[smallItem.id] || ''}
                  placeholder={smallItem.setsumon_comment}
                  onChange={(e) =>
                    changed(['answerItems', smallItem.id], e.target.value)
                  }
                />
              </td>
            );
          }

          if (!isBigItemDisplayed) {
            rows.push(
              <tr key={`bigItem-${bigItem.id}`}>
                <td colSpan="4" style={{ paddingLeft: '15px', fontWeight: 'bold' }}>
                  {bigItem.setsumon_title}
                </td>
              </tr>
            );
            isBigItemDisplayed = true;
          }

          rows.push(
            <tr key={`smallItem-${smallItem.id}`}>
              {smallItemTitle}
              {choiceInputs}
              {smallItemComment}
            </tr>
          );
        });
      });

      return rows;
    };

    const renderTable2 = (bigItem) => {
      let rows = [];
      const linkedMediumQuestions = mediumQuestionItems.filter(
        (mediumItem) => mediumItem.big_question_id == bigItem.id
      );

      if (!firstType2Set) {
        rows.push(
          <tr key={`title-${bigItem.id}`}>
            <td colSpan="17" style={{ fontWeight: 'bold', fontSize: '1.3em' }}>
              ２．質問事項
            </td>
          </tr>
        );
        firstType2Set = true;
      }

      let isBigItemDisplayed = false;

      linkedMediumQuestions.forEach((mediumItem) => {
        let isMediumItemDisplayed = false;
        const linkedSmallQuestions = smallQuestionItems.filter(
          (smallItem) =>
            smallItem.big_question_id == bigItem.id &&
            smallItem.medium_question_id == mediumItem.id
        );

        if (!isBigItemDisplayed) {
          const paddingTopValue = !firstBigItemDisplayed ? "5px" : "20px";
          rows.push(
            <tr key={`bigItem-${bigItem.id}`}>
              <td
                colSpan="17"
                style={{ paddingTop: paddingTopValue, paddingLeft: "15px", fontWeight: "bold" }}
              >
                <div style={{ fontSize: '1.3em' }}>{bigItem.setsumon_title}</div>
                {bigItem.setsumon_comment ? bigItem.setsumon_comment.split("\\n").map((part, index) => (
                    <span key={index} style={{ display: "block", paddingLeft: "15px", fontWeight: "bold" }}>
                      {part}
                    </span>
                  ))
                : null}
              </td>
            </tr>
          );
          isBigItemDisplayed = true;
          if (!firstBigItemDisplayed) {
            firstBigItemDisplayed = true;
          }
        }

        rows.push(
          <tr key={`mediumItem-${mediumItem.id}`}>
            <td colSpan="17" style={{ paddingLeft: "15px", fontWeight: "bold" }}>
              {mediumItem.setsumon_text.split('\\n').map((line, index) => (
                <span key={index}>
                  {line}
                  <br />
                </span>
              ))}
            </td>
          </tr>
        );

        let choiceHeaders = [];
        let choiceInputs2 = {}; // 動的に管理するオブジェクトに変更
        let summaryTableFlg = false;
        let smallIndex = 1; // 初期の smallIndex
        let inputTitle = null;
        let inputText = null;

        linkedSmallQuestions.forEach((smallItem) => {
          const key = `${mediumItem.id}-${smallItem.setsumon_text}`;

          // keyが変わるタイミングでsmallIndexをリセット
          if (!choiceInputs2[key] && smallItem.setsumon_type != 10) {
            smallIndex = 1; // smallIndexをリセット
            choiceInputs2[key] = { inputs: [], sum: 0 }; // 合計値を格納するためのオブジェクトに変更

            // ヘッダー（<th>）を最初に追加する処理
            choiceInputs2[key].inputs.push(
              <th style={{ backgroundColor: "#f1f1f1", textAlign: "center", border: "1px solid", fontWeight: "bold", fontSize:"85%" }} key={`label-${key}`} >
                {smallItem.setsumon_text.split('\\n').map((line, index) => (
                <span key={index}>
                  {line}
                  <br />
                </span>
                ))}
              </th>
            );
          }
          if (smallItem.setsumon_type == 0 && smallItem.summary_flg == 1) {
            summaryTableFlg = true;

            // 集計表ヘッダーの管理
            if (!choiceHeaders.some((header) => header.props.children == smallItem.setsumon_text2)) {
              choiceHeaders.push(
                <th key={`header-${smallItem.id}`} style={{ width: "7%", backgroundColor: "#f1f1f1", border: "1px solid" }}>
                  {smallItem.setsumon_text2}
                </th>
              );
            }

            // 入力フィールドと合計計算
            choiceInputs2[key].inputs.push(
              <td style={{ border: "1px solid" }} key={`input-${smallItem.id}`}>
                <input type="text" data-medium={mediumItem.id} data-small={smallIndex} onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ""))}
                  value={answerItems[smallItem.id] || ''}
                  onChange={(e) => {
                    changed(['answerItems', smallItem.id], e.target.value)
                    const newValue = e.target.value.replace(/[^0-9]/g, ""); // 数字以外を削除
                    this.setState((prevState) => ({
                      inputs: {
                        ...prevState.inputs,
                        [smallItem.id]: newValue, // 状態を更新
                      },
                    }));
                    this.sumChanged(key, e); // 合計計算
                  }}
                  style={{ width: "80%", textAlign: "right", appearance: "textfield" }}
                />
              </td>
            );
            smallIndex++; // smallIndexをインクリメント
          } else if(smallItem.setsumon_type == 0 && (smallItem.summary_flg == 0 || smallItem.summary_flg == null)) {
            rows.push(
              <tr key={`wrapper-${smallItem.id}`}>
                <td colSpan="17">
                  <div className="subtable-container">
                    <table style={{ width: "90%", margin: "10px", borderCollapse: "collapse" }}>
                      <tbody>
                      <tr key={`input-${smallItem.id}`}>
                        <th style={{ width: "20%", textAlign: "center" }} key={`label-${key}`}>
                          {smallItem.setsumon_text}
                        </th>
                        <td>
                          <textarea className='span10' value={answerItems[smallItem.id] || ''} onChange={(e) => changed(['answerItems', smallItem.id], e.target.value)} />
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            );
          } else if(smallItem.setsumon_type == 4) {
            const linkedChoises = choiseItems.filter(choiseItem => choiseItem.choise_type == smallItem.setsumon_type);
            rows.push(
              <tr key={`wrapper-${smallItem.id}`}>
                <td colSpan="17">
                  <div className="subtable-container">
                    <table style={{ width: "90%", margin: "0 20px", borderCollapse: "collapse" }}>
                      <tbody>
                      <tr key={`input-${smallItem.id}`}>
                        <td style={{ width: "85%", fontWeight: "bold" }}>
                          {smallItem.setsumon_text}
                        </td>
                        <td rowSpan="2">
                          <select value={answerItems[smallItem.id] || ''} onChange={(e) => changed(['answerItems', smallItem.id], e.target.value)} style={{ maxWidth: '150px' }}>
                            <option value="">選択してください</option>
                            {linkedChoises.map((choise, choiceIndex) => (
                              <option key={choiceIndex} value={choise.choise_sort}>
                                {choise.choise_text}
                              </option>
                            ))}
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: "0 20px", fontWeight: "bold" }}>
                          {smallItem.setsumon_text2}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            );
          } else if(smallItem.setsumon_type == 5) {
            const linkedChoises = choiseItems.filter(choiseItem => choiseItem.choise_type == smallItem.setsumon_type);
            rows.push(
              <tr key={`wrapper-${smallItem.id}`}>
                <td colSpan="17">
                  <div className="subtable-container">
                    <table style={{ width: "90%", margin: "0 20px", borderCollapse: "collapse" }}>
                      <tbody>
                      <tr key={`input-${smallItem.id}`}>
                        <td style={{ width: "20%", fontWeight: "bold" }}>
                          {smallItem.setsumon_text}
                        </td>
                        <td rowSpan="2">
                          <select value={answerItems[smallItem.id] || ''} onChange={(e) => changed(['answerItems', smallItem.id], e.target.value)} style={{ maxWidth: '150px' }}>
                            <option value="">選択してください</option>
                            {linkedChoises.map((choise, choiceIndex) => (
                              <option key={choiceIndex} value={choise.choise_sort}>
                                {choise.choise_text}
                              </option>
                            ))}
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: "0 20px", fontWeight: "bold" }}>
                          {smallItem.setsumon_text2}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            );
          } else if(smallItem.setsumon_type == 6) {
            const linkedChoises = choiseItems.filter(choiseItem => choiseItem.choise_type == smallItem.setsumon_type);
            rows.push(
              <tr key={`wrapper-${smallItem.id}`}>
                <td colSpan="17">
                  <div className="subtable-container">
                    <table style={{ width: "90%", margin: "0 20px", borderCollapse: "collapse" }}>
                      <tbody>
                      <tr>
                        <td colSpan="2" style={{ fontWeight: "bold" }}>
                          {smallItem.setsumon_text.split('\\n').map((line, index) => (
                            <span key={index}>
                              {line}
                              <br />
                            </span>
                          ))}
                        </td>
                      </tr>
                      <tr key={`input-${smallItem.id}`}>
                        <td style={{ width: "85%", padding: "0 20px", textAlign: "right", fontWeight: "bold" }}>
                          {smallItem.setsumon_text2}
                        </td>
                        <td>
                          <select value={answerItems[smallItem.id] || ''} onChange={(e) => changed(['answerItems', smallItem.id], e.target.value)} style={{ maxWidth: '150px' }}>
                            <option value="">選択してください</option>
                            {linkedChoises.map((choise, choiceIndex) => (
                              <option key={choiceIndex} value={choise.choise_sort}>
                                {choise.choise_text}
                              </option>
                            ))}
                          </select>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            );
          } else if(smallItem.setsumon_type == 7) {
            rows.push(
              <tr key={`wrapper-${smallItem.id}`}>
                <td colSpan="17">
                  <div className="subtable-container">
                    <table style={{ width: "30%", margin: "10px", border: "1px solid", borderCollapse: "collapse" }}>
                      <tbody>
                      <tr key={`input-${smallItem.id}`}>
                        <th style={{ width: "40%", backgroundColor: "#f1f1f1", textAlign: "center", border: "1px solid", fontWeight: "bold" }} key={`label-${key}`}>
                          {smallItem.setsumon_text}
                        </th>
                        <td>
                          <input type="text" value={answerItems[smallItem.id] || ''} onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ""))}
                            onChange={(e) => changed(['answerItems', smallItem.id], e.target.value)}
                            style={{ width: "80%", textAlign: "right", appearance: "textfield" }}
                          /> 円
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            );
          } else if(smallItem.setsumon_type == 8) {
            if (inputTitle != smallItem.setsumon_text) {
              rows.push(
                <tr key={`title-${smallItem.id}`}>
                  <td colSpan="17" style={{ fontWeight: "bold" }}>
                    {smallItem.setsumon_text}
                  </td>
                </tr>
              );
            }

            rows.push(
              <tr key={`wrapper-${smallItem.id}`}>
                <td colSpan="17">
                  <div className="subtable-container">
                    <table style={{ width: "100%", margin: "10px", borderCollapse: "collapse", fontWeight: "bold" }}>
                      <tbody>
                        <tr key={`input-${smallItem.id}`}>
                          <th style={{ width: "30%", padding: "0 10px", textAlign: "left", fontWeight: "bold" }}>
                            {smallItem.setsumon_text2}
                          </th>
                          <td style={{ width: "20%" }}>
                            <input
                              type="text"
                              value={answerItems[smallItem.id] || ""}
                              onChange={(e) => changed(["answerItems", smallItem.id], e.target.value)}
                              onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ""))}
                              style={{ width: "50%", textAlign: "right", appearance: "textfield" }}
                            />{" "}
                            件
                          </td>
                          <td style={{ width: "50%" }}></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            );

            inputTitle = smallItem.setsumon_text;
          } else if(smallItem.setsumon_type == 9) {
            const linkedChoises = choiseItems.filter(choiseItem => choiseItem.choise_type == smallItem.setsumon_type);
            rows.push(
              <tr key={`wrapper-${smallItem.id}`}>
                <td colSpan="17">
                  <div className="subtable-container">
                    <table style={{ width: "90%", margin: "0 20px", borderCollapse: "collapse" }}>
                      <tbody>
                      <tr key={`input-${smallItem.id}`}>
                        <td style={{ width: "85%", fontWeight: "bold" }}>
                          {smallItem.setsumon_text}
                        </td>
                        <td>
                          <select value={answerItems[smallItem.id] || ''} onChange={(e) => changed(['answerItems', smallItem.id], e.target.value)} style={{ maxWidth: '150px' }}>
                            <option value="">選択してください</option>
                            {linkedChoises.map((choise, choiceIndex) => (
                              <option key={choiceIndex} value={choise.choise_sort}>
                                {choise.choise_text}
                              </option>
                            ))}
                          </select>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            );
          } else if(smallItem.setsumon_type == 10) {
            if (inputTitle != smallItem.setsumon_text) {
              rows.push(
                <tr key={`wrapper-${smallItem.id}`}>
                  <td colSpan="17">
                    <div className="subtable-container">
                      <table style={{ width: "100%", margin: "10px", borderCollapse: "collapse", fontWeight: "bold" }}>
                        <tbody>
                          <tr key={`input-${smallItem.id}`}>
                            <th style={{ width: "15%", padding: "0 10px", textAlign: "left", fontWeight: "bold" }}>
                              {smallItem.setsumon_text}
                            </th>
                            <td style={{ width: "35%" }}>
                              <input
                                type="text"
                                value={answerItems[smallItem.id] || ""}
                                onChange={(e) => changed(["answerItems", smallItem.id], e.target.value)}
                                onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ""))}
                                style={{ width: "30%", textAlign: "right", appearance: "textfield" }}
                              />{" "}
                              社　
                              {smallItem.setsumon_text2}
                            </td>
                            <td style={{ width: "50%" }}></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              );
            }
            inputTitle = smallItem.setsumon_text;
          } else if(smallItem.setsumon_type == 11) {
            const linkedChoises = choiseItems.filter(choiseItem => choiseItem.choise_type == smallItem.setsumon_type);
            rows.push(
              <tr key={`wrapper-${smallItem.id}`}>
                <td colSpan="17">
                  <div className="subtable-container">
                    <table style={{ width: "90%", margin: "0 20px", borderCollapse: "collapse" }}>
                      <tbody>
                      <tr key={`input-${smallItem.id}`}>
                        <td style={{ width: "85%", fontWeight: "bold" }}>
                          {smallItem.setsumon_text}
                        </td>
                        <td>
                          <select value={answerItems[smallItem.id] || ''} onChange={(e) => changed(['answerItems', smallItem.id], e.target.value)} style={{ maxWidth: '150px' }}>
                            <option value="">選択してください</option>
                            {linkedChoises.map((choise, choiceIndex) => (
                              <option key={choiceIndex} value={choise.choise_sort}>
                                {choise.choise_text}
                              </option>
                            ))}
                          </select>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            );
          }
        });

        // 合計を表示するセルを追加
        if (summaryTableFlg) {
          let showJapaneseSum = false;
          let showForeignerSum = false;
          let showForeignerSubscriberSum = false;
          let isNewHireSummary = false;

          linkedSmallQuestions.forEach(smallItem => {
          const text = smallItem.setsumon_text;
            if (text.includes("日本人")) showJapaneseSum = true;
            if (text.includes("外国人加入者")) showForeignerSubscriberSum = true;
            // 「外国人」を含み、「加入者」でもないものを「通常の外国人」と判定
            if (text.includes("外国人") && !text.includes("外国人加入者")) {
              showForeignerSum = true;
            }
            if (text.includes("入職者")) {
              isNewHireSummary = true;
              showJapaneseSum = false;
              showForeignerSum = false;
              showForeignerSum = false;
            }
          });

          // 外国人加入者が含まれる場合は日本人計を表示しない
          if (showForeignerSubscriberSum) {
            showJapaneseSum = false;
          }

          rows.push(
            <table style={{ width: "100%", margin: "10px", border: "1px solid", borderCollapse: "collapse" }}>
              <tbody>
                <tr key={`smallItem-header-${mediumItem.id}`}>
                  <th style={{ width: "9px", backgroundColor: "#f1f1f1", border: "1px solid", fontWeight: "bold" }}>
                    項目
                  </th>
                  {choiceHeaders}
                  <th style={{ width: "7%", backgroundColor: "#f1f1f1", border: "1px solid", fontWeight: "bold" }}>
                    合計
                  </th>
                </tr>
                {Object.keys(choiceInputs2).map((key) => {
                  const isExclusionRow = key.includes('適用除外'); 
                  // 適用除外の項目が見つかったら、ここで「外国人加入者計」を挿入する
                  if (isExclusionRow) {
                      const foreignerSubscriberRow = (() => {
                        const showForeignerSubscriberSum = true;
                        if (!showForeignerSubscriberSum) return null;
                        const mediumId = mediumItem.id;
                        const sums = this.state.foreignerSubscriberSumByIndex[mediumId] || {};
                        const indices = Object.keys(sums).sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
                        const totalSum = Object.values(sums).reduce((acc, val) => acc + val, 0);

                        return (
                          <tr key={`summary-foreignerSubscriber-inserted-${mediumId}`} style={{ backgroundColor: "#f7f7f7" }}>
                            <th style={{ backgroundColor: "#f1f1f1", border: "1px solid", fontWeight: "bold", fontSize: "85%" }}>
                              外国人加入者計
                            </th>
                            {indices.map((index) => (
                              <td key={`cell-foreignerSubscriber-${index}`} style={{ textAlign: "right", padding: "0 10px", border: "1px solid" }}>
                                  {sums[index]}
                              </td>
                            ))}
                            <td key={`total-foreignerSubscriber`} style={{ textAlign: "right", padding: "0 10px", border: "1px solid" }}>
                              {totalSum}
                            </td>
                          </tr>
                        );
                      })();

                      return [
                        foreignerSubscriberRow,
                        <tr key={key}>
                          {choiceInputs2[key].inputs}
                          <td style={{ width: "7%", textAlign: "right", padding: "0 10px", border: "1px solid", background: "#f7f7f7" }}>
                            {this.state.choiceInputs2[key] ? this.state.choiceInputs2[key].sum : 0}
                          </td>
                        </tr>
                      ];
                  }

                  // 適用除外以外の行は通常通りレンダリング
                  return (
                    <tr key={key}>
                      {choiceInputs2[key].inputs}
                      <td style={{ width: "7%", textAlign: "right", padding: "0 10px", border: "1px solid", background: "#f7f7f7" }}>
                        {this.state.choiceInputs2[key] ? this.state.choiceInputs2[key].sum : 0}
                      </td>
                    </tr>
                  );
                }).flat()}

                {[
                  { show: showJapaneseSum, title: "日本人計", data: this.state.japaneseSumByIndex },
                  { show: showForeignerSum, title: "外国人計", data: this.state.foreignerSumByIndex },
                ].map((summary, i) => {
                  if (!summary.show) return null;
                  const mediumId = mediumItem.id;
                  const sums = summary.data[mediumId] || {};
                  // 年代のインデックスを取得してソート
                  const indices = Object.keys(sums).sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
                  // 合計（横計）を計算
                  const totalSum = Object.values(sums).reduce((acc, val) => acc + val, 0);

                  return (
                    <tr key={`summary-${i}-${mediumId}`} style={{ backgroundColor: "#f7f7f7" }}>
                      <th style={{ backgroundColor: "#f1f1f1", border: "1px solid", fontWeight: "bold", fontSize: "85%" }}>
                        {summary.title}
                      </th>
                      {indices.map((index) => (
                        <td key={`cell-${i}-${index}`} style={{ textAlign: "right", padding: "0 10px", border: "1px solid" }}>
                          {sums[index]}
                        </td>
                      ))}
                      <td key={`total-${i}`} style={{ textAlign: "right", padding: "0 10px", border: "1px solid" }}>
                        {totalSum}
                      </td>
                    </tr>
                  );
                })}

                {(() => {
                  const mediumId = mediumItem.id;
                  const unknownData = this.state.unknownUnsubscribedSumByIndex[mediumId];
                  // 該当する中項目IDのデータが存在する場合のみ表示
                  if (unknownData) {
                    const indices = Object.keys(unknownData).sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
                    const totalSum = Object.values(unknownData).reduce((acc, val) => acc + val, 0);

                    return (
                      <tr key={`unknown-unsubscribed-${mediumId}`} style={{ backgroundColor: "#f7f7f7" }}>
                        <th style={{ backgroundColor: "#f1f1f1", border: "1px solid", fontWeight: "bold", fontSize: "85%" }}>
                          未加入・不明
                        </th>
                        {indices.map((index) => (
                          <td key={`unknown-${index}`} style={{ textAlign: "right", padding: "0 10px", border: "1px solid" }}>
                            {unknownData[index]}
                          </td>
                        ))}
                        <td key={`unknown-total`} style={{ textAlign: "right", padding: "0 10px", border: "1px solid" }}>
                          {totalSum}
                        </td>
                      </tr>
                    );
                  }
                  return null;
                })()}

                <tr key={`smallItem-summary-${mediumItem.id}`} style={{ backgroundColor: "#f7f7f7" }}>
                  <th style={{ width: "9px", backgroundColor: "#f1f1f1", border: "1px solid", fontSize: "85%" }}>
                    {isNewHireSummary ? <span>各年代入職者<br />合計{summaryCnt}</span> : `各年代合計${summaryCnt}`}
                  </th>
                  {(() => {
                    const mediumId = mediumItem.id;
                    // displaySumByIndex からデータを取得
                    const sums = this.state.displaySumByIndex[mediumId] || {};
                    const indices = Object.keys(sums).sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
                    
                    const cells = indices.map((index) => (
                      <td key={`summary-cell-${index}`} style={{ textAlign: "right", padding: "0 10px", border: "1px solid" }}>
                        {sums[index]}
                      </td>
                    ));

                    // 合計欄 (横合計)
                    const totalSum = Object.values(sums).reduce((acc, val) => acc + val, 0);
                    cells.push(
                      <td key={`summary-total`} style={{ textAlign: "right", padding: "0 10px", border: "1px solid" }}>
                        {totalSum}
                      </td>
                    );
                    
                    return cells;
                  })()}
                </tr>
              </tbody>
            </table>
          );
        }

        if(mediumItem.setsumon_comment) {
          rows.push(
            <tr key={`mediumComment-${mediumItem.id}`}>
              <td colSpan="17" style={{ paddingLeft: "20px" }}>
                {mediumItem.setsumon_comment.split('\\n').map((line, index) => (
                  <span key={index}>
                    {line}
                    <br />
                  </span>
                ))}
              </td>
            </tr>
          );
        }

        summaryCnt++
      });

      return rows;
    };

    return (
      <fieldset>
        <legend>{survey.surveyMainItems.year}年度 {survey.surveyMainItems.title}</legend>
        <div className="text-right">一般社団法人日本型枠工事業協会（略称：日本型枠）</div>
        <br />

        {/* タイプ1のテーブル */}
        <table style={{ width: '90%', margin: '0 auto', borderCollapse: 'collapse' }}>
          <tbody>
            {bigQuestionItems
              .filter((bigItem) => bigItem.setsumon_type == 1)
              .map((bigItem, index) => renderTable1(bigItem))}
          </tbody>
        </table>

        <br />

        {/* タイプ2のテーブル */}
        <table style={{ width: '90%', margin: '0 auto', borderCollapse: 'collapse' }}>
          <tbody>
            {bigQuestionItems
              .filter((bigItem) => bigItem.setsumon_type == 2)
              .map((bigItem, index) => renderTable2(bigItem))}
          </tbody>
        </table>
      </fieldset>
    );
  }
  onFormButtonClicked (name, e) {
    e.preventDefault()
    const id = this.state.id
    switch (name) {
      case 'save':
        this.saveServey()
        break
      case 'cancel':
        this.props.history.push('/company_user/')
        break
      default:
        break
    }
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />;
    }

    // surveyQuestionDataが無い場合
    if (!this.state.surveyMainItems || !Object.keys(this.state.surveyMainItems).length) {
      return (
        <div>
          <section className='nav-page'>
            <div className='container'>
              <div className='row'>
                <div className='span7'>
                  <header className='page-header'>
                    <h3>アンケート回答<br /><small>こちらでアンケートの回答をできます。</small></h3>
                  </header>
                </div>
                <div className='span9'>
                  <ul className='nav nav-pills'>
                    <li className='kw-btn-area'>
                      <button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}>
                        <i className='icon-arrow-left icon-large' />
                        <span>戻る</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
          <section className='page container'>
            <div className='container'>
              <div className='kw-ic-info-regist-area span16' style={{ marginBottom: '150px' }}>
                <p>現在、回答可能なアンケートはありません。</p>
              </div>
            </div>
          </section>
        </div>
      );
    }

    let buttonLayout = null;
    if (this.state.surveyMainItems.shimeFlg) {
      buttonLayout = (
        <footer className='form-actions' id='submit-actions'>
          <div className='kw-ic-info-regist-area' style={{ fontWeight: "bold" }}>
            <p>アンケートは締め切りました。</p>
          </div>
          <button disabled className='btn btn-gray' onClick={(e) => this.onFormButtonClicked('save', e)}>
            保存
          </button>
          <button className='btn btn-default' onClick={(e) => this.onFormButtonClicked('cancel', e)}>
            キャンセル
          </button>
        </footer>
      );
    } else {
      buttonLayout = (
        <footer className='form-actions' id='submit-actions'>
          <button className='btn btn-primary' onClick={(e) => this.onFormButtonClicked('save', e)}>
            保存
          </button>
          <button className='btn btn-default' onClick={(e) => this.onFormButtonClicked('cancel', e)}>
            キャンセル
          </button>
        </footer>
      );
    }

    let summaryCnt = 1;
    const surveyDetail = this.renderSurveyDetail(this.state, summaryCnt);

    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>アンケート回答<br /><small>こちらでアンケートの回答をできます。</small></h3>
                </header>
              </div>
              <div className='span9'>
                <ul className='nav nav-pills'>
                  <li className='kw-btn-area'>
                    <button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}>
                      <i className='icon-arrow-left icon-large' />
                      <span>戻る</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          <form className='form-horizontal' method='post' onKeyDown={(e) => {if (e.key === 'Enter') {e.preventDefault();}}}>
            <div className='container'>
              <div className='kw-ic-info-regist-area span16'>
                {surveyDetail}
                {buttonLayout}
              </div>
            </div>
          </form>
        </section>
      </div>
    );
  }
}

export default SurveyAnswer



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/SurveyAnswer.js